import { Model } from '@/models/Model';
export class GraduationProfile extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'GraduationProfile';
        this.$endpoint = '/exit-profiles';
        this.$fillable = [
            'name',
        ];
    }
    async attachStudents(students, current_subjects_to_inactive) {
        console.log('current_subjects_to_inactive:: ', current_subjects_to_inactive);
        const url = `${this.$endpoint}/${this.id}/attach-students`;
        return this.request('post', url, { user_ids: students, current_subjects_to_inactive });
    }
}
